import TemplateIllustration from './TemplateIllustration.component';

export default TemplateIllustration;
